export class OrganizationModel {
  organizationType: any;
  organizationId: number;
  name: string;
  invoiceReceiverNo: number;
  organizationNo: string;
  description: string;
  isActive: boolean;
  organizationTypeId: number;
  imoCompanyNumber: string;
  clearanceIsNullString: string;
  clearanceIsTrueString: string;
  clearanceIsFalseString: string;
}



// WEBPACK FOOTER //
// ./src/app/shared/models/organization-model.ts